export const VISIBILITY_DURATION = 4000; // ms
export const TRANSITION_DURATION = 250;

// max number of visible messages
export const MAX_COUNT = 4;
